import { render } from "./CustomTextField.vue?vue&type=template&id=04fad7b3&scoped=true"
import script from "./CustomTextField.vue?vue&type=script&lang=js"
export * from "./CustomTextField.vue?vue&type=script&lang=js"

import "./CustomTextField.vue?vue&type=style&index=0&id=04fad7b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04fad7b3"]])

export default __exports__